var render = function render(){var _vm=this,_c=_vm._self._c;return _c('yandex-map',{ref:"mglMap",staticClass:"map",attrs:{"settings":_vm.ymSettings,"coords":_vm.center,"zoom":_vm.zoom,"controls":_vm.controls},on:{"update:coords":function($event){_vm.center=$event},"update:zoom":function($event){_vm.zoom=$event},"map-was-initialized":_vm.mapInitializedHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }